const initSubmissionToNewsletter = () => {
  const Intro = document.querySelector('.footer__newsletter .intro');
  const form = document.querySelector('.footer__newsletter .footer__newsletter-form');
  const fieldBlock = form.querySelector('.footer__newsletter-inner');
  const fieldInput = form.querySelector('#footer-external-subscribe-email');
  const responseMessage = form.querySelector('.footer__newsletter-response-message');
  const messageIcon = responseMessage.querySelector('.icon');
  const messageMain = responseMessage.querySelector('.main');
  const messageSub = responseMessage.querySelector('.sub');
  if (!form) return;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();

    const {
      proxyUrl
    } = window.assetUrls;

    const [proxyModule] = await Promise.all([
        import(proxyUrl)
    ]);

    const { submissionToNewsletter } = proxyModule;

    const getFormData = () => {
      var formData = new FormData(); //When using form-data, its Content-Type defaults to multipart/form-data.
      formData.append('email', fieldInput.value);

      return formData;
    };

    const result = await submissionToNewsletter( getFormData() );
    //console.log(requestData);console.log(result);
    form.reset();
    Intro?.classList.add('hidden');
    fieldBlock?.classList.add('hidden');
    fieldInput.value = '';
    responseMessage.classList.remove('hidden');

    if (result?.status && ['SUBSCRIBED', 'PENDING', 'FAILED'].includes(result.status)) {
      switch (result.status) {
        case 'SUBSCRIBED':
          messageMain.innerHTML = window.themeTranslations.subscribedMain;
          break;
        case 'PENDING':
          messageMain.innerHTML = window.themeTranslations.pendingMain;
          messageSub.innerHTML = window.themeTranslations.pendingSub;
          break;
        case 'FAILED':
          messageMain.innerHTML = window.themeTranslations.failedMain;
          messageSub.innerHTML = window.themeTranslations.failedSub;
          break;
      }
    } else {
      messageMain.innerHTML = window.themeTranslations.error;
      console.error(window.themeTranslations.error);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initSubmissionToNewsletter();
})